<template>
    <div style="background:white" class="ve-list-page">
        <div style=" display:flex; min-width:1200px; background:#fFF;line-height:30px; border-bottom:2px solid #389;">
            <div style="display:flex;padding-top:3px">
                <div style="width:90px ; " >
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:10px;;font-weight:600">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
                <div style="margin-right:5px;font-size:12px;margin-left:10px;">{{ $LANG('0358', '状态') }}</div>
                <el-select v-model="stfgSet"  size="small" @change="stfgChange(stfgSet)" style="width:90px">
                    <el-option :label="$LANG('0321', '所有')" value="ALL"></el-option>
                    <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                    <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
                    <el-option :label="$LANG('1991', '已隐藏')" value="H"></el-option>
                </el-select>
                <div style="margin-right:5px;font-size:12px;margin-left:5px;">{{ $LANG('0298', '字段') }}</div>
                <el-select @change="txtparam=''" v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:120px;  ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-select v-model="oper"  size="small" style="width:90px;  ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <span v-if="selparam=='SUPTYNM'">
                    <el-select v-model="txtparam" clearable @change="qryTabData" size="small" style="width:200px;  ">
                        <span v-for="item in suptyArr" :key='item.SUBNO'>
                            <el-option :label="item.CNAME" :value="item.CNAME"></el-option>
                        </span>
                    </el-select>
                </span>
                <span v-else>
                    <el-input clearable :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:200px;  ">
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    </el-input> 
                </span>
                <el-button :disabled="editBool"  @click="setHide( 'Y')" type="danger" plain size="mini" style="height:28px;margin-top:2px;margin-left:20px; ">
                    <i class="iconfont icon-shezhi" style=" font-size:12px;margin-right:3px"></i>{{ $LANG('0413', '设置隐藏') }}
                </el-button>
                <el-button :disabled="editBool"  @click="setHide( 'N')" type="warning" plain size="mini" style="height:28px;margin-top:2px;margin-left:20px; ">
                    <i class="iconfont icon-chexiao" style=" font-size:12px;margin-right:3px"></i>{{ $LANG('0316', '取消隐藏') }}
                </el-button>
 
                <el-button  @click="openFieldSettingsDialog().catch(() => {})" type="warning" plain size="small" style="height:30px;margin-top:1px;margin-left:20px;border:1px solid #f00">
                    <i class="iconfont icon-shezhi" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0683', '字段设置')}}
                </el-button>
            </div>
        </div> 
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :scroll-width="0"
                :column-width-resize-option="columnWidthResizeOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                id="sys_sup_one"
                :cellSelectionOption="{enable: false}"
                ref="tabref">
        </ve-table>
        </div>
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <div v-for="(gpitem,gpind) in formArr" :key="gpind" >
                    <div class="one-div" v-if="gpitem.gpno!=='400070'&&gpitem.gpno!=='400071'&&gpitem.gpno!=='304'" >
                        <span class="oneRow">{{gpitem.gpnm}} </span> 
                        <el-link v-if="gpitem.gpno==='20284'" :underline="false" @click="perAdd">【{{ $LANG('0095', '新增记录') }}】</el-link>
                    </div>
                    <Form :model="perRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.FLDNM" :class=" item.EDCSS=='textarea'?'item-one':'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="perRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :disabled="saveFlag" :precision="item.DOTNUM" v-else-if="item.EDCSS==='number'" v-model="perRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" :disabled="item.DISABLED=='Y'" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="perRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select> 
                                <el-cascader size="medium" v-else-if=" item.FLDNO==='AREA'"  style="width:100%" :placeholder="$LANG('1663', '请输入')+$LANG('0123', '关键字')+$LANG('0142', '查找')"
                                    v-model="perRow[item.FLDNO]"  :disabled="saveFlag"
                                    clearable
                                    filterable
                                    :options="areaArr">
                                </el-cascader>
                                <el-input size="medium" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="perRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </div>
                <div  class="one-div">
                    <span class="oneRow">{{ $LANG('1132', '联系人资料') }}
                        <el-button :disabled="saveFlag" @click="perAdd" type="primary" plain size="mini" style="height:25px;margin-top:2px; border:1px solid #409eff">
                            <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px"></i>{{ $LANG('1105', '新增联系人') }}
                        </el-button>
                    </span>        
                </div>
                <el-table  :data="perData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    ref="pertab"
                    :cell-style="{padding:'2px'}"
                    :height="250" 
                    style="margin-top:-8px"
                    highlight-current-row > 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                    <el-table-column  v-for="(item,index ) in perCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                                       
                        sortable
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled  true-label="Y"  false-label="N" v-model="scope.row[item.key]" > &nbsp;</el-checkbox> 
                            <span v-else v-text="scope.row[item.key]"></span>
                        </template>
                    </el-table-column> 
 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button size="small" :disabled="saveFlag"  type="text" icon="el-icon-edit" @click="perEdit(scope.row,scope.$index)">{{ $LANG('1639', '编辑') }}</el-button>
                            <el-button size="small" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="perDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                        </template>
                    </el-table-column>                        
                </el-table>

                <div  class="one-div" style="height:28px">
                    <span class="oneRow"  >{{ $LANG('0236', '上传营业执照附件 (建议为图片或PDF格式）') }} *</span>
                </div>
                <div style="display:flex;margin-top:5px;height:150px;overflow-y:auto;" >
                    <Upload
                        name="upfile"
                        ref="upload"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="(file) =>beforeImgFile(file,'MER')"
                        :on-success="successImgFile"
                        :on-progress="handleProgress"
                        :with-credentials="true"
                        :max-size="10240"
        
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :action="uploadUrl" 
                        style="display: inline-block;width:150px; ">
                        <div style="padding: 1px 0;width:150px;height:130px;" >
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>  
                    </Upload>
                    <div style="display:flex;margin-left:10px;flex-wrap:wrap;margin-right:10px;"  >
                        <span v-for="(item,index) in imgData.filter(item=>item.FILETY=='MER')" :key="index">
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                                <div   slot="error" style="color:red;font-weight:600">{{ $LANG('', '文件名：') }}{{item['FILENM']}}</div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                                <el-link v-else :underline="false" style="margin-right:3px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                            </div>
                        </span>
                    </div>
                </div>
                <div  class="one-div" style="margin-top:10px">
                    <span class="oneRow">{{ $LANG('0237', '上传资格证书附件 (最多个文档，可以是或图片格式）') }}</span>                    
                </div>
                <div style="display:flex;margin-top:5px;height:150px;overflow-y:auto;" >
                    <Upload
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="(file) =>beforeImgFile(file,'CERT')"
                        :on-success="successImgFile"
                        :on-progress="handleProgress"
                        :with-credentials="true"
                        :max-size="10240"
 
                        :on-exceeded-size="handleMaxSize"
                        type="drag"       
                        :action="uploadUrl" 
                        style="display: inline-block;width:150px; ">
                        <div style="padding: 1px 0;width:150px;height:130px;" >
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>                                                       
                    </Upload>
                    <div style="display:flex;margin-left:30px;flex-wrap:wrap"  >
                        <span v-for="(item,index) in imgData.filter(item=>item.FILETY=='CERT')" :key="index">
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                                <div   slot="error" style="color:red;font-weight:600">{{ $LANG('', '文件名：') }}{{item['FILENM']}}</div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                    <el-link   :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                                <el-link v-else :underline="false" style="margin-right:3px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                            </div>
                        </span>
                    </div>
                </div>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-right:40px;height:35px;vertical-align:middle"></i>
                    </span>
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="drawer=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                        <el-button :disabled="saveFlag" type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag :title="$LANG('1442', '提示')" :visible.sync="promptWin"  width="450px"  :close-on-click-modal="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 联系人资料框 -->
        <el-dialog  v-dialogDrag :visible.sync="perWin"  width="1000px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{perFlag==='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
            </div>
            <Form :model="contRow" :label-width="120"  label-position="right" inline  >  
                <span v-for="(item,index) in perCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="contRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="contRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="contRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form> 
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="perWin = false" style="margin-right:40px;">{{ $LANG('0132', '取消') }}</el-button>
                <el-button type="primary" size="small" @click="perSure">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>
 
</template>
<script>
import { startWorkflowInstance } from '@/utils/workflowDesigner.js' 
import { getTabColOrData,getBaseData } from '../../api/user';
import {  getDate} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
import FileSaver from 'file-saver'
//局部注册
export default {
    name:"sys_supinfo",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '100',
            fieldIdseq: '100',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            delData:[],
            drawer:false,
            saveFlag:false,
            contRow:{},
            promptWin:false,
            prompt:'',
            stfgCss:'',
            operArr:[],
            perRow:{},
            perData:[],
            loadingInstance: null,
            imgData:[],
            listIndex:'-1',
            active:'', //二级菜单选中标志
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
 
            tabArr:[], //表列
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            eventCustomOption: {},
            areaArr:[], //国家地区
            perCol:[],
            oper:'like',
            comboArr:[],
            txtparam:'',
            selparam:'IDNO',
            d_stfg:false,
            stfgColor:'',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            delArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            perFlag:'create',
            perWin:false,
            rowIndex:'',
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            uploadData:{}, //上传数据
            v_action:'',
            fileName:'',
            v_row:{},
            queryRequestId:0,
            videoFlag:false,
            videoUploadPercent:0,
            showViewer:false,
            listurl:'',
            suptyArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限 :frmid:100 供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','100','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        this.comSelect()
        //国家地区
        getBaseData('xuper_auth/getCascadeData','parentno','308' ,'','','v_sys_base','').then(res=>{
            this.areaArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','284','','','v_sys_base','').then(res=>{
            this.suptyArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','100','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            this.formArr = res.result             
 
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','100','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','100','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
    },
    computed: {
        leftHeight: function() {
            return (window.innerHeight - 90) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 100) + 'px';
        },
    },
    components: {
        repWin,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#sys_sup_one"),
                name: "wave",
            })
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
       
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: { 
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择正确的图片或PDF格式 ')
        },
 
        downFile(filePath){
            const arr_name=filePath.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(filePath,file_name)
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt = this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
          
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
          
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
         setHide(val){
            const v_data =this.tabData.filter(item=>item['SEL']=='Y')
            if (v_data.length==0){
               this.promptWin =true
               this.prompt=this.$LANG('1701', '请选择行记录')
               return
            }
            if (val=='N'){
                const v_hide=v_data.filter(item=>item['ISHIDE']=='N').length
                if (v_hide>0){
                    this.promptWin =true
                    this.prompt=this.$LANG('1569', '请选择隐藏行记录')
                    return
                }
            }
            if (val=='Y'){
                const v_hide=v_data.filter(item=>item['ISHIDE']=='Y').length
                if (v_hide>0){
                    this.promptWin =true
                    this.prompt=this.$LANG('1570', '请选择非隐藏行记录')
                    return
                }
            }
            let v_cond =' set ishide=\''+val+'\'  '
            let v_comm =val=='Y' ?'隐藏':'取消隐藏'     
            this.$confirm(this.$LANG('1564', '你确定要')+this.$LANG(val=='Y'?'0413':'0316', v_comm)+this.$LANG('1566', '所选择的记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(async ()=>{
  
                // forEach 不支持异步等待 不能直接用 forEach + async/await 只能用 for 循环
                const v_confirm =v_data.map(async item=>{
                    return await this.$axios({   
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq', p_value:item['IDSEQ'],  p_table:'BS_SUP',p_cond:v_cond},
                    }) 
                })
            
                const results = await Promise.all(v_confirm).then(()=>{
                    this.qryTabData() 
                })
                       
                    
              
            }).catch(()=>{})
        },
        chkSel(){
            this.tabData.forEach(item=>item['SEL']=this.v_row['SEL'])
        },
        rowShow(){
            this.v_row = {}
            this.qryTabData()
        } ,
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{ //
                let v_index =this.imgData.findIndex(v=>v['IDSEQ']===item['IDSEQ'] && v['LSTSEQ']===item['LSTSEQ'])
                this.imgData.splice(v_index, 1)
                this.delData.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH']})
                
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },

        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' '+this.$LANG('1561', '文件太大， 不能超出')+'10M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:this.v_action,PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})
            } else{
                this.promptWin =true
                this.prompt =res.result
            }  
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (file,v_code) {    
            this.v_action= v_code
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        perSure(){
            if (!this.contRow['EMPNM']){
                this.promtWin=true
                this.prompt=this.$LANG('0296', '姓名')+this.$LANG('2051', '不能为空')
            }else{
                this.perWin =false
                if (this.perFlag==='edit' ){ //编辑时要替换数组记录
                    this.perData.splice(this.rowIndex,1,this.contRow)
                }else{
                    this.perData.push(this.contRow)
                }
            }
        },
        perEdit(row ,index){
            this.contRow=JSON.parse(JSON.stringify(row))
            this.perWin=true
            this.perFlag='edit'
            this.rowIndex=index
        } ,
        perDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.perData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        perAdd(){
            this.contRow={'STFG':'N'}
            this.perFlag='create'
            this.perWin=true
        },
        //查询联系人数据
        getPerData(idseq){
            this.perData=[]
            getTabColOrData(this.v_url,'V_BS_supEMP','idseq',idseq).then((res) => {
                
                this.perData =res.result  
            })
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'100',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        saveRec(){
            var area_=''
            var vm =this 
            if (typeof(this.perRow['AREA'])!=='undefined' && this.perRow['AREA']!==''){
                area_ =this.perRow['AREA'].join(',') 
            } 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.perRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {    
                let obj_ ={}      
                Object.assign(obj_,vm.perRow,{'AREA': area_, 'CORPID':this.v_corpid}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'bs_sup',frmid:'100'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        //联络人保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.perData), p_table:'BS_supEMP',p_idseq:res.idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promtWin=true
                                 this.prompt=res.result
                             }
                         })
                         //联络人删除
                         if (this.delArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delArr), p_table:'BS_supEMP',p_idseq:res.idseq,p_action:'D' },
                            })
                         }
                        //3、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:res.idseq},
                            })
                        }
                        //删除服务器上的真实附件
                        for(let k=0;k<this.delData.length;k++){
                            let v_filepath=this.delData[k]['FILEPATH'],v_path=this.delData[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delData[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delData[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delData[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{
                                //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                    this.$axios({
                                        method: 'post',
                                        url: '/xuper_oss/ftpDelete',
                                        data: {p_path:'/volume1'+v_path},
                                    }).then(res=>{
                                        console.log(res.result)
                                    })
                                }
                            })
                        }
                        vm.drawer =false   
                        vm.qryTabData()
                    }else{
                        this.promptWin =true
                        if (res.result.indexOf('ORA-00001')>-1){
                            this.prompt =this.$LANG('1895', '已存在此供应商名称的记录,请核查')
                        }else{
                            this.prompt =res.result
                        }
                    }        
                }) 
            }
 
        },
        delRec(row,index){
            let vm =this
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'SUPNO', p_value:row['IDSEQ'],p_key2:'corpid', p_value2:this.v_corpid,p_cond:' AND STFG NOT IN (\'X\')',p_table:'v_po_ord'},
                }).then(res=>{ 
                    if (res.result.length>0){
                        this.promptWin =true
                        this.prompt =this.$LANG('1911', '此供应商已被采购订单引用，不能删除')
                    }else{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_SUP',p_cond:' set stfg=\'X\'' },
                        }).then(res=>{ 
                            this.tabData.splice(index,1)
                        })
                    }
                })
            })
        } ,
        //状态审核
        stfgRec(row,val,index,v_comm){
            
            var vm=this ,v_cond='',v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser='' ,v_title=''
            if (val =='K') {
                if( v_comm=='弃审'){
                    v_cfmdttm =''
                    v_cfmuser =''
                }else{
                    v_cfmdttm =getDate('full')
                    v_cfmuser =this.v_usernm
                }
                v_chkuser='',v_chkdttm=''
                v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\''
            }
            let v_bool =false
            if( v_comm=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_bool =true
                }
            }
            const translatedComm = v_comm === '弃审' ? this.$LANG('0137', '弃审') : v_comm === '弃认' ? this.$LANG('0314', '弃认') : v_comm === '确认' ? this.$LANG('0364', '确认') : v_comm === '审核' ? this.$LANG('0134', '审核') : v_comm === '作废' ? this.$LANG('0257', '作废') : v_comm
            v_title =this.$LANG('1564', '你确定要')+translatedComm+this.$LANG('1566', '此行记录吗')
            if (v_bool){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1049', ' 与审核用户：')+row['CHKUSER']+this.$LANG('1646', ' 不同时不能弃审')
            }else{
                this.$confirm(v_title,this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    type:'info',
                }).then(()=>{
                    this.d_stfg=true
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_sup',p_cond: v_cond},
                    }).then(res=>{      
                        if(res.code =='200')  {
                            if (val=='X'){
                                this.tabData.splice(index,1)
                            }else{        
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm,CFMUSER:v_cfmuser,CFMDTTM:v_cfmdttm})           
                            }
                        }else{
                            this.prompt=res.result
                            this.promptWin =true
                        }        
                    })
                    //发起审批时
                    if (val =='K'){
                        // 调用工作流启动函数
                        startWorkflowInstance({
                            flowId: '100',
                            businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                            actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                            component: this,
                            axios: this.$axios,
                            baseUrl:  '',
                            // 微信消息相关参数
                            docType: '供应商资料', // 单据类型
                            DIRNM: row.SUPNM, // 项目名称，使用文件名
                            CNAME: row.MATNM,
                            businessData: {
                                flowType: 3,
                                qty: null,
                                amt: row['TTLAMT'],
                            },
                            jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                        })
                        this.d_stfg=false
                    }else if( v_comm =='弃认'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'P\''},
                        }).then(res=>{
                            this.d_stfg=false
                            // 在日志表中 插入 一条 弃认记录
                            let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃认'}
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                            }) 
                        })
                    }else if( v_comm =='弃审'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'Y\' and iscc=0'},
                        }).then(res=>{
                            // 在日志表中 插入 一条 弃认记录
                            let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:'发起人 弃审'}
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                            }).then(res=>{ 
                                this.d_stfg=false  
                            })
                        })
                    }else{
                        this.d_stfg=false
                    }
                   
                }).catch(()=>{})  
            }          
        },
        //供应商明细
        getSupList(cond){
            this.loadingInstance.show()
            const requestId = ++this.queryRequestId
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'v_bs_sup'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        const table = this.$refs.tabref
                        if (table && typeof table.doLayout === 'function') table.doLayout()
                        this.loadingInstance.close()
                    })
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadingInstance.close()
                }
                
            }).catch(error => {
                if (requestId !== this.queryRequestId) return
                this.loadingInstance.close()
                this.promptWin = true
                this.prompt = error && error.message ? error.message : this.$LANG('1641', '查询失败')
            })
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin =true
                    this.prompt =this.$LANG('1721', '请输入跳至页数')
  
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
               
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        selRec(row){

        },
        editRec(row,val){
            let row_=''
            if (row.AREA){
                try{
                    row_ =row.AREA.split(',')
                    Object.assign(row,{AREA:row_})
                }catch(err){
                    //    
                }
            }
            this.perRow =JSON.parse(JSON.stringify(row))
            this.drawer=true
            this.qryImgData(row.IDSEQ)
            if(row.STFG==='Y'){
               // this.saveFlag=true
                this.stfgCss='icon-yishenhe1'
                this.stfgColor='color:green'
            } else {
                this.saveFlag=val=='Y'?true :false
                this.stfgCss=row.STFG=='N'?'icon-weishenhe3':'icon-yizuofei'
            }
            this.getPerData(row.IDSEQ)
        },
        qryImgData(idseq){
            getTabColOrData(this.v_url, 'V_mat_img','idseq',idseq,'','','','',' order by lstseq').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            this.current = 1
            const queryFields = this.initCol.filter(item => (item.key || item.FLDNO) !== 'SEL')
            const cond_ = buildVeTableFieldCondition(queryFields, this.selparam, this.txtparam, this.oper)
            const v_cond = buildVeTableHeaderCondition(queryFields, this.v_row, { numberOperatorDefault: '>=' })
            if (this.stfgSet=='ALL'){
                this.getSupList(cond_+v_cond + ' and ishide!=\'Y\' ')
            }else if (this.stfgSet=='H'){
                this.getSupList(cond_+v_cond + ' and ishide=\'Y\' ')
            } else { // 
                this.getSupList(' and ishide!=\'Y\' and stfg=\''+this.stfgSet+'\'' + cond_+v_cond)
            }
        },
        //新增供应商 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.perRow={SUPTY:this.active}
            this.perData= []
            this.imgData=[]
            this.saveFlag=false
        },
        //状态查询
        stfgChange(val){
            this.qryTabData()
        },
 
 
        //二级菜单点击事件
        itemClick(frmurl ){
            this.active =frmurl
 
        },
        //获取表列字段
        getTabField(){
            const vm = this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','100','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        vm.tabArr.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            sortable: item.SORTABLE,
                            holder: item.HOLDER,
                        })
                        if (item.THIDE !== 'N') return
                        const column = {
                            field: item.key,
                            key: item.key,
                            title,
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: item.SORTABLE === 'N',
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({ column: headerColumn }) => (
                                item.key === 'SEL' ? (
                                    <div>
                                        <div style="margin-top:3px;white-space:nowrap">{headerColumn.title}</div>
                                        <el-checkbox on-change={() => vm.chkSel()} true-label="Y" false-label="N" v-model={vm.v_row[item.key]}></el-checkbox>
                                    </div>
                                ) : <VeTableQueryHeader
                                    title={headerColumn.title}
                                    edcss={item.EDCSS}
                                    value={vm.v_row[item.key]}
                                    operator={vm.v_row[`#OPER${item.key}`]}
                                    showDateOperator={false}
                                    options={String(item.EDCSS || '').toLowerCase() === 'select' ? (vm.comboArr[item.key] || []) : []}
                                    on-input={(value) => vm.$set(vm.v_row, item.key, value)}
                                    on-operator-change={(value) => vm.$set(vm.v_row, `#OPER${item.key}`, value)}
                                    on-query={() => vm.qryTabData()}
                                />
                            ),
                            renderBodyCell: ({ row }) => {
                                if (item.key === 'SEL') return <el-checkbox true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                if (item.key === 'ISHIDE') {
                                    return row[item.key] === 'Y'
                                        ? <el-tag size="mini" type="success">{vm.$LANG('2047', '是')}</el-tag>
                                        : <el-tag size="mini" type="info">{vm.$LANG('2044', '否')}</el-tag>
                                }
                                if (item.key === 'STFG') {
                                    if (row[item.key] === 'Y') return <el-tag size="mini" type="success" effect="dark">{vm.$LANG('1976', '已审核')}</el-tag>
                                    if (row[item.key] === 'N') return <el-tag size="mini" type="info" effect="dark">{vm.$LANG('2005', '未审核')}</el-tag>
                                    if (row[item.key] === 'X') return <el-tag size="mini" type="info" effect="dark">{vm.$LANG('1964', '已作废')}</el-tag>
                                    return <el-tag size="mini" type="danger" effect="dark">{vm.$LANG('1961', '审核中')}</el-tag>
                                }
                                if (item.key === 'IDNO') return <el-link underline={false} on-click={() => vm.repBtn(row)}><span style="color:#409eff;border-bottom:1px solid red;font-size:12px">{row[item.key]}</span></el-link>
                                if (item.EDCSS === 'checkbox') return row[item.key] === 'Y'
                                    ? <el-tag size="mini" type="success" effect="dark">{vm.$LANG('2047', '是')}</el-tag>
                                    : <el-tag size="mini" type="info" effect="dark">{vm.$LANG('2044', '否')}</el-tag>
                                return row[item.key]
                            },
                        }
                        vm.vueCol.push(column)
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderHeaderCell: () => (
                            <el-link on-click={() => vm.rowShow()} style="font-size:12px;color:#404eff">
                                <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                            </el-link>
                        ),
                        renderBodyCell: ({ rowIndex }) => <span style="color:#1890ff">{rowIndex + 1}</span>,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 220,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({ row, rowIndex }) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => vm.editRec(row, 'Y')} underline={false}><span style="font-size:12px;margin-right:8px">{vm.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={vm.editBool} on-click={() => vm.editRec(row, 'N')} underline={false}><span style="font-size:12px;margin-right:8px">{vm.$LANG('1639', '编辑')}</span></el-link></span> : null}
                                {row.STFG === 'N' ? <span><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'K', rowIndex, '确认')} underline={false}><span style="font-size:12px;margin-right:8px">{vm.$LANG('0364', '确认')}</span></el-link></span> : null}
                                {row.STFG === 'K' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={vm.editBool} on-click={() => vm.stfgRec(row, 'N', rowIndex, '弃认')} underline={false}><span style="font-size:12px;margin-right:5px">{vm.$LANG('0314', '弃认')}</span></el-link></span> : null}
                                {row.STFG === 'Y' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'N', rowIndex, '弃审')} underline={false}><span style="font-size:12px;margin-right:8px">{vm.$LANG('0137', '弃审')}</span></el-link></span> : null}
                                {row.STFG === 'N' ? <span><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={vm.cancelBool} on-click={() => vm.delRec(row, rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{vm.$LANG('0257', '作废')}</span></el-link></span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            }).catch(() => {})
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','100','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.perCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .item-one {
        width: 97%;
        //height:88px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-body-cell-class1 {
        height: 20px !important;
        padding: 2px !important;
        color: black !important;
        font-size: 12px !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
   .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
   .el-cascader-panel{
        height: 60vh;
        .el-scrollbar__wrap{
            height:100%;
        }
    }
</style>
